const STYLES = {
    fontSize: 12,
    margin: [0, 0, 0, 16],
    alignment: 'left',
    color: '#000000',
    fillColor: '#f5f5f5',
    borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  };

const TABLE_CELL = {
    fontSize: STYLES.fontSize,
    borderColor: STYLES.borderColor,
  };

const TABLE_HEADER = {
    fontSize: STYLES.fontSize,
    fillColor: STYLES.fillColor,
    borderColor: ['#f5f5f5', '#6d6d6d', '#f5f5f5', '#6d6d6d'],
  };

const TABLE_LAYOUT = {
    hLineWidth() { return 1; },
    vLineWidth() { return 0; },
    paddingLeft() { return 8; },
    paddingRight() { return 8; },
    paddingTop() { return 8; },
    paddingBottom() { return 8; },
  };

export default {
  STYLES,
  TABLE_CELL,
  TABLE_HEADER,
  TABLE_LAYOUT,
};
